import { Pto } from '@outcoreaix/pto'

export const getStarterFallbackColor = (index: number): string =>
  Pto.AppTemplates.StarterFallbackColors[index % Pto.AppTemplates.StarterFallbackColors.length]
